import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, Mail, FileText } from 'lucide-react';
const trustItems = [{
  icon: Lock,
  title: 'Pago seguro',
  desc: 'Procesamos tu pago con la máxima seguridad a través de Shopify.'
}, {
  icon: Zap,
  title: 'Entrega inmediata',
  desc: 'Recibís el PDF en tu email inmediatamente después del pago.'
}, {
  icon: Mail,
  title: 'Soporte',
  desc: 'Si tenés alguna duda, escribinos por email o WhatsApp y te respondemos en menos de 24hs.'
}, {
  icon: FileText,
  title: 'Formato PDF',
  desc: 'Leelo en tu celular, tablet o computadora. Sin apps, sin complicaciones.'
}];
export function TrustSection() {
  return <section className="bg-navy text-white py-24 px-6" data-id="element-313">
      <div className="max-w-4xl mx-auto" data-id="element-314">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-315">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-316">
            Tu compra es 100% segura
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-317">
          {trustItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-800 p-6 rounded-xl border border-slate-700 flex items-start gap-4" data-id="element-318">
              <div className="bg-slate-700 p-3 rounded-lg text-green-400 flex-shrink-0" data-id="element-319">
                <item.icon size={24} data-id="element-320" />
              </div>
              <div data-id="element-321">
                <h3 className="font-bold text-lg mb-2 text-white" data-id="element-322">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-323">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}